import Vue from 'vue'
import Cookies from 'js-cookie'
import App from './App.vue'
import router from './router'
import store from './store'
import elementUI from 'element-ui' // js
import { Swipe, SwipeItem } from 'vant'
import '@vant/touch-emulator'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VTooltip from 'v-tooltip'
import 'element-ui/lib/theme-chalk/index.css' // css
import './styles/main.css' // css
import 'element-ui/lib/theme-chalk/display.css'
import i18n from './utils/i18n' // internationalization
import 'vant/lib/swipe/style'
import '@/assets/font/font.css'
import 'swiper/dist/css/swiper.css'
import '@/assets/iconfont/iconfont.css'
Vue.use(VueAwesomeSwiper)
// import MataInfo from 'vue-meta-info' // internationalization
// Vue.use(MataInfo)
Vue.use(elementUI, {
  size: Cookies.get('size') || 'medium', // set element-ui default size
  i18n: (key, value) => i18n.t(key, value)
})
Vue.config.productionTip = false
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(elementUI)
Vue.use(VTooltip)
new Vue({
  router,
  i18n,
  store,
  mounted() {
    document.dispatchEvent(new Event('custom-render-trigger'))
  },
  render: h => h(App)
}).$mount('#app')
